import type {ReactElement} from 'react';
import React from 'react';
import {BaseTextListOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-text-list-option';
import type {LIST_STYLE, LIST_TYPES} from '@PosterWhiteboard/items/text-item/text-list';
import type {FillObject} from '@PosterWhiteboard/classes/fill.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromListOfActiveItem';
import {useGetKeyFromFillOfTextStylesOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfTextStylesOfActiveItem';
import {useGetKeyFromFillOfListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfListOfActiveItem';

interface TextListOptionProps {
  onClickColorObject(): void;
}

export function TextListOption({...props}: TextListOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const fillType = useGetKeyFromFillOfTextStylesOfActiveItem('fillType');
  const fillColor = useGetKeyFromFillOfTextStylesOfActiveItem('fillColor');
  const listType = useGetKeyFromListOfActiveItem('type');
  const listStyle = useGetKeyFromListOfActiveItem('style');
  const listWidth = useGetKeyFromListOfActiveItem('width');
  const listFillType = useGetKeyFromFillOfListOfActiveItem('fillType');
  const listFillColor = useGetKeyFromFillOfListOfActiveItem('fillColor');

  if (
    !activeItem ||
    (activeItem && !('list' in activeItem)) ||
    !fillColor ||
    !listFillColor ||
    listFillType === undefined ||
    listType === undefined ||
    listWidth === undefined ||
    listStyle === undefined
  ) {
    throw new Error("item doesn't have list property");
  }

  const updateListObject = (type: LIST_TYPES, styleToApply?: LIST_STYLE): void => {
    let style: LIST_STYLE;
    if (!styleToApply) {
      style = activeItem.list.getDefaultListStyleFromType();
    } else {
      style = styleToApply;
    }

    let newFillObject: Partial<FillObject> = {};

    if (!activeItem.list.hasList()) {
      newFillObject = {
        fillColor: fillColor,
        fillType: fillType,
      };
    }

    void activeItem.updateFromObject({
      list: {
        type,
        style,
        fill: newFillObject,
      },
    });
  };

  return (
    <BaseTextListOption
      onClickColorObject={(): void => {
        props.onClickColorObject();
      }}
      listObject={{
        type: listType,
        style: listStyle,
        width: listWidth,
        fill: {
          fillColor: listFillColor,
          fillType: listFillType,
        },
      }}
      isUnordered={activeItem.list.isUnordered()}
      isOrdered={activeItem.list.isOrdered()}
      onUpdateListObject={updateListObject}
    />
  );
}
